export default __webpack_public_path__ + "static/media/Film_peritiliksis.3acfaaee.jpg";